<template></template>

<script>
import AppDisplayPost from './AppDisplayPost.vue';

export default {
	components: {
		'app-display-post': AppDisplayPost
	},
	data() {
		return {
			route: 'fest_movie',
			searchTerm: '',
			wpPosts: [], // REST API response data goes here.
			filteredPosts: [],
			wpData, // global data made available via wp_localize_script.
			activeDates: [],
			contentFilters: {}
		};
	},
	computed: {

		// computed property to get filtered data based on search key or category filter.
	},
	mounted() {

		// get posts from the WordPress REST API on component creation.
		this.fetchData();
		this.emitter.on('filterByDate', this.filterByDate)
		this.emitter.on('filterByContent', this.filterByContent)
		this.emitter.on('searchTermChanged', this.filterBySearchTerm);
		this.emitter.on('resetFilteredPosts', this.resetFilters);
		this.emitter.on('filterByQueryParamTag', this.filterByQueryParamTag) 
		this.emitter.on('getFilteredPosts', _ => {
			this.emitter.emit('filteredPosts', this.filteredPosts)
		});
	},
	methods: {
		filterByQueryParamTag(tag) {
			this.filterByContent({
				name: "tags",
				active: [tag]
			}, true)
		},
		filterByDate(activeDates) {
			this.activeDates = activeDates;
			this.filterResults()
		},
		filterByContent(filterObj, resetOtherFilters) {
			if (resetOtherFilters) {
				this.searchTerm = '';
				this.activeDates = [];
				this.contentFilters = {};
			}
			this.contentFilters[filterObj.name] = filterObj.active
			this.filterResults()
		},
		filterBySearchTerm(newSearchTerm) {
			this.searchTerm = newSearchTerm;
			this.filterResults()
		},
		resetFilters() {
			this.searchTerm = [];
			this.activeDates = [];
			this.contentFilters = {};
			this.filterResults()
		},

		// fetch posts only if fetchNow is greater than 0.
		fetchData() {
			this.getPosts( this.route );
		},
		async getPosts( route = 'fest_movie', namespace = 'wp/v2' ) {
			try {

				/* Note: the per_page argument is capped at 100 records by the REST API.
				 * https://developer.wordpress.org/rest-api/using-the-rest-api/pagination/
				 */

				const restURL = this.wpData.rest_url;

				// send an initial request and await the response to get the total number of posts.
				const response = await fetch(
					`${restURL}/${namespace}/${route}?orderby=title&order=asc`
				);

				this.wpPosts = await response.json();
				this.emitter.emit('gotPosts', this.wpPosts)
				this.filterNow = !this.filterNow
				this.filterResults()
			} catch ( error ) {
				console.log(` The request could not be processed! <br> <strong>${error}</strong> `);
			}
		},
		filterResults() {
			if ( this.wpPosts.length ) {
				let filteredPosts = this.wpPosts.slice();

				// Filter posts that are a colection item
				filteredPosts = filteredPosts.filter(movie => !movie['custom_fields']['collection_item'].length)

				if (this.searchTerm) {
					// match keyword against post titles or excerpts.
					const pattern = new RegExp( this.searchTerm, 'i' );
					filteredPosts = filteredPosts.filter( post => {
						return (
							post.title.rendered.match( pattern )
						);
					});
				}

				// further filter the results based on the date
				if ( this.activeDates && this.activeDates.length ) {
					let activeDates = this.activeDates.map(dateText => dateText.match(/(\d){2}\.(\d){2}/)[0])
					filteredPosts = filteredPosts.filter( function(post) {
					 	if (!post.custom_fields['screening_hours_and_events']) return false
						else return post.custom_fields['screening_hours_and_events'].some( function(screening) {
							// match date string e.g "Wednesday 27.10" => "27.10"
								if (!screening.date || typeof(screening.date) != "string") return false
								return activeDates.includes(screening.date.match(/(\d){2}\.(\d){2}/)[0])
							}
						)}
					);
				} 

				// further filter the results based on content (competition, crowd, tags)
				if ( this.contentFilters && Object.entries(this.contentFilters).length ) {
					const that = this
					for (let type in that.contentFilters) {
						if (!that.contentFilters[type].length) continue
						filteredPosts = filteredPosts.filter( function(post) {
							if (!post[type]) return false
							else return post[type].some( typeTaxonomy => that.contentFilters[type].includes(typeTaxonomy.name) )
						});
					}
				} 
				this.filteredPosts = filteredPosts
				this.emitter.emit('filteredPosts', filteredPosts)
			} else {
				this.getPosts()
			}
		}
	}
};
</script>

<style scoped></style>
